import React, { useState } from 'react';
import './styles.css';
import Icon, { CloseOutlined } from '@ant-design/icons';
import { ReactComponent as InfoIcon } from '@BUP/assets/Icons/info.svg';

const NotificationHelper = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`${isOpen ? 'notification-helper-container' : 'notification-helper-container minimal'}`}>
      {
        isOpen ? (
          <div className="notification-content">
            <Icon
              component={InfoIcon}
              className="notification-icon"
            />
            <CloseOutlined
              onClick={() => setIsOpen(false)}
              className="close-icon"
            />
            <p className="notification-title-text">Guía para el buen uso</p>
            <a href="https://s3-us-west-1.amazonaws.com/resources.app.braveup/Descripci%C3%B3n+del+MODO+BUP!+(Todos+los+miembros+de+la+comunidad).pdf" target="_blank">
              <p className="notification-body-text">¿Qué es el MODO BRAVE UP!?</p>
            </a>
            <a href="https://s3-us-west-1.amazonaws.com/resources.app.braveup/Preguntas+frecuentes+MODO+BRAVE+UP!+2021.pdf" target="_blank">
              <p className="notification-body-text">Preguntas Frecuentes </p>
            </a>
          </div>
        ) : (
            <Icon
              component={InfoIcon}
              onClick={() => setIsOpen(true)}
              className="notification-icon"
            />
          )
      }
    </div>
  )
}

export default NotificationHelper;